import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    display: flex;
    padding-bottom: 50px;
    z-index: 10;
    margin-top: 5px;
    right: ${displayState?.left !== null ? 0 : 'unset'};
    left: ${displayState?.left !== null ? displayState.left + 'px' : 'unset'};
  `}
`

export default Wrapper(template);